import React from "react";
import type { PriorityFaultEvent } from "diagnostics-domain/faultEvent";
import Text from "@ui/Text";
import CountBar from "./CountBar";
import { getEventPriorityText, getEventPriorityColor } from "../../../Events/utils/event";

interface Props {
  priority: PriorityFaultEvent;
  value: number;
  total: number;
}

const CountPriorityBar = ({ priority, value, total }: Props) => {
  const priorityText = getEventPriorityText(priority);
  const priorityColor = getEventPriorityColor(priority);
  return (
    <React.Fragment key={priority}>
      <Text type="body2">{priorityText}</Text>
      <CountBar
        value={value}
        total={total}
        fillColor={priorityColor.backgroundColor}
        textColor={priorityColor.textColor}
      />
    </React.Fragment>
  );
};

export default CountPriorityBar;
